var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstelle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 264 313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-width: 3.4px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-3, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-6 {\n        fill: #c97c3c;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-7 {\n        fill: #f4b497;\n      }\n\n      .cls-8 {\n        fill: #414a4c;\n      }\n\n      .cls-9 {\n        fill: #eeb68c;\n      }\n\n      .cls-10 {\n        fill: #373db0;\n      }\n\n      .cls-11 {\n        fill: #f5c13d;\n      }\n\n      .cls-12 {\n        fill: #b7c8d8;\n      }\n\n      .cls-13 {\n        fill: #ee927e;\n      }\n\n      .cls-14 {\n        fill: #f6c09c;\n      }\n\n      .cls-15 {\n        fill: #a86732;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-19 {\n        fill: #db9d2a;\n      }\n\n      .cls-3 {\n        stroke: #033040;\n        stroke-width: 24.93px;\n      }\n\n      .cls-20 {\n        fill: #fff;\n      }\n\n      .cls-21 {\n        fill: #e3af5b;\n      }\n\n      .cls-22 {\n        fill: #ffe4bf;\n      }\n\n      .cls-23 {\n        fill: #000d19;\n      }\n\n      .cls-24 {\n        fill: #f8c79d;\n      }\n\n      .cls-25 {\n        fill: #073f4a;\n      }\n\n      .cls-4 {\n        stroke: #c97c3c;\n        stroke-width: 2px;\n      }\n\n      .cls-26 {\n        fill: #556ec9;\n      }\n\n      .cls-27 {\n        fill: #f68181;\n      }\n\n      .cls-28 {\n        fill: #fa98be;\n      }\n\n      .cls-5 {\n        stroke: #000d19;\n        stroke-width: 2.27px;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-30 {\n        fill: #002131;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M101.86,131.34h24.34c7.19,0,13.02,5.83,13.02,13.02v4.3c0,3.88-3.15,7.02-7.02,7.02h-36.34c-3.88,0-7.02-3.15-7.02-7.02v-4.3c0-7.19,5.83-13.02,13.02-13.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M157.86,94.09h-19.56c-4.04,0-6.4-4.56-4.07-7.85l1.43-2.02c6.06-8.57,18.78-8.57,24.84,0l1.43,2.02c2.33,3.3-.03,7.85-4.07,7.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M100.3,94.09h19.56c4.04,0,6.4-4.56,4.07-7.85l-1.43-2.02c-6.06-8.57-18.78-8.57-24.84,0l-1.43,2.02c-2.33,3.3.03,7.85,4.07,7.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "177.91 178.56 170.78 173.18 176.65 169.73 177.91 178.56"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 148.5,
    cy: 249.5,
    rx: 111.5,
    ry: 58.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.55,149l-14.66,7.33c-6.31,3.15-10.29,9.6-10.29,16.65v57.81h36.62v-74.57c0-5.99-6.31-9.89-11.67-7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M79.67,149l-14.66,7.33c-6.31,3.15-10.29,9.6-10.29,16.65v55.25l36.62-19.74v-52.27c0-5.99-6.31-9.89-11.67-7.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 55.87,
    y: 228.66,
    width: 4.26,
    height: 43.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 88.79,
    y: 206.38,
    width: 4.26,
    height: 43.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 101.8,
    y: 228.66,
    width: 4.26,
    height: 43.57
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "133.46 201.49 133.46 208.03 91.16 208.03 63.92 224.25 54.72 224.25 54.72 230.79 66.33 230.79 115.47 230.79 143.34 208.03 143.34 201.49 133.46 201.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "115.47 224.25 54.72 224.25 91.16 201.49 143.34 201.49 115.47 224.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.98,20.58h40.67c11.81,0,21.4,9.59,21.4,21.4v103.19c0,20.04-16.27,36.3-36.3,36.3h-26.52c-20.04,0-36.3-16.27-36.3-36.3V57.64c0-20.45,16.61-37.06,37.06-37.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 134.29,
    y: 124.35,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(350.8 156.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 96.82,
    y: 152.91,
    width: 34.43,
    height: 26.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M101.86,131.34h24.34c7.19,0,13.02,5.83,13.02,13.02v4.3c0,3.88-3.15,7.02-7.02,7.02h-36.34c-3.88,0-7.02-3.15-7.02-7.02v-4.3c0-7.19,5.83-13.02,13.02-13.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M100.37,131.34h32.49v5.77c0,4.73-3.84,8.57-8.57,8.57h-15.35c-4.73,0-8.57-3.84-8.57-8.57v-5.77h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M104.88,171.72h18.3c12.37,0,22.42,10.05,22.42,22.42v9.49h-63.14v-9.49c0-12.37,10.05-22.42,22.42-22.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 96.82,
    y: 168.71,
    width: 34.43,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 96.82,
    y: 154.24,
    width: 34.43,
    height: 8.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M156.33,251.07l-3.48-9.16c-3.14-8.28,2.97-17.14,11.83-17.14h0c8.86,0,14.97,8.86,11.83,17.14l-3.48,9.16c-2.92,7.69-13.79,7.69-16.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M129.72,259.9l-3.48-9.16c-3.14-8.28,2.97-17.14,11.83-17.14h0c8.86,0,14.97,8.86,11.83,17.14l-3.48,9.16c-2.92,7.69-13.79,7.69-16.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M157.07,229.2h15.23v6.67c0,2.85-2.31,5.16-5.16,5.16h-4.91c-2.85,0-5.16-2.31-5.16-5.16v-6.67h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 54.72,
    y1: 224.25,
    x2: 89.84,
    y2: 202.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M130.46,238.02h15.23v6.67c0,2.85-2.31,5.16-5.16,5.16h-4.91c-2.85,0-5.16-2.31-5.16-5.16v-6.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M152.57,203.86c0,8.01-6.49,14.5-14.5,14.5h-41.11c-8.01,0-14.5-6.49-14.5-14.5s6.49-14.5,14.5-14.5h41.11c8.01,0,14.5,6.49,14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M123.57,244.72v-41.11c0-8.01,6.49-14.5,14.5-14.5s14.5,6.49,14.5,14.5v41.11h-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M179.18,194.78c0,8.01-6.49,14.5-14.5,14.5h-41.11c-8.01,0-14.5-6.49-14.5-14.5s6.49-14.5,14.5-14.5h41.11c8.01,0,14.5,6.49,14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M150.18,235.89v-41.11c0-8.01,6.49-14.5,14.5-14.5s14.5,6.49,14.5,14.5v41.11h-29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.56,172.71c-.71-.71-1.86-.71-2.57,0-.71.71-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.49,172.71c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.62,172.71c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M116.62,183.56h4.6v11.24c0,2.54-2.06,4.6-4.6,4.6h0v-15.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M109.74,11.79h13.74c21.52,0,38.99,17.47,38.99,38.99v29.67c0,8.75-7.1,15.85-15.85,15.85h-60.03c-8.75,0-15.85-7.1-15.85-15.85v-29.67c0-21.52,17.47-38.99,38.99-38.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M104.41,39.82h38.77c11.66,0,21.12,9.47,21.12,21.12v39.74c0,18.71-15.19,33.9-33.9,33.9h-13.21c-18.71,0-33.9-15.19-33.9-33.9v-39.74c0-11.66,9.47-21.12,21.12-21.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 104.33,
    y: 116.21,
    width: 19.4,
    height: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M131.12,89.22l7.34,20.73c.63,1.77-.69,3.64-2.57,3.64h-3.27c-2.03,0-3.68-1.65-3.68-3.68v-20.31c0-1.26,1.75-1.56,2.17-.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M157.86,94.09h-19.56c-4.04,0-6.4-4.56-4.07-7.85l1.43-2.02c6.06-8.57,18.78-8.57,24.84,0l1.43,2.02c2.33,3.3-.03,7.85-4.07,7.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 145.67,
    y: 82.16,
    width: 14.31,
    height: 24.01,
    rx: 7.15,
    ry: 7.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 144.14,
    y: 79.6,
    width: 6.15,
    height: 11.21,
    rx: 3.07,
    ry: 3.07
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.79,86.99s4.82-9.2,14.29-9.2c10.31,0,14.28,9.2,14.28,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 160.74,
    y1: 77.51,
    x2: 157.5,
    y2: 80.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.79,
    y1: 74.52,
    x2: 153.74,
    y2: 78.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 164.68,
    y1: 81.22,
    x2: 161,
    y2: 84.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M100.3,94.09h19.56c4.04,0,6.4-4.56,4.07-7.85l-1.43-2.02c-6.06-8.57-18.78-8.57-24.84,0l-1.43,2.02c-2.33,3.3.03,7.85,4.07,7.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 107.3,
    y: 82.16,
    width: 14.31,
    height: 24.01,
    rx: 7.15,
    ry: 7.15,
    transform: "translate(228.91 188.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 105.61,
    y: 79.6,
    width: 6.15,
    height: 11.21,
    rx: 3.07,
    ry: 3.07,
    transform: "translate(217.37 170.41) rotate(180)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.37,86.99s-4.82-9.2-14.29-9.2c-10.31,0-14.28,9.2-14.28,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.42,
    y1: 77.51,
    x2: 100.65,
    y2: 80.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.36,
    y1: 74.52,
    x2: 104.41,
    y2: 78.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.47,
    y1: 81.22,
    x2: 97.15,
    y2: 84.23
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M157.83,88.58h11.48v2.31c0,7.24-5.88,13.12-13.12,13.12h0c-2.77,0-5.02-2.25-5.02-5.02v-3.76c0-3.67,2.98-6.66,6.66-6.66Z",
    transform: "translate(320.48 192.58) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M93.37,88.58h0c7.24,0,13.12,5.88,13.12,13.12v2.31h-11.48c-3.67,0-6.66-2.98-6.66-6.66v-3.76c0-2.77,2.25-5.02,5.02-5.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 94.64,
    cy: 101.5,
    r: 7.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 163.51,
    cy: 101.5,
    r: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M129.59,121.49s-1.72-3.77-6.99-6.04c-5.26-2.27-9.43-.48-9.43-.48,0,0,1.52,4.1,7.15,6.38,4.02,1.63,9.27.15,9.27.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "240.46 224.08 236.32 228.16 236.32 158.89 240.46 154.8 240.46 224.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 230.36,
    y: 158.89,
    width: 5.96,
    height: 69.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "119.61 271.69 115.47 275.78 115.47 206.5 119.61 202.41 119.61 271.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 109.51,
    y: 206.5,
    width: 5.96,
    height: 69.28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "181.25 271.69 177.11 275.78 177.11 206.5 181.25 202.41 181.25 271.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 171.15,
    y: 206.5,
    width: 5.96,
    height: 69.28
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.77,46h9.16c15.4,0,27.88,12.48,27.88,27.88v87.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "209.28 153.52 209.28 160.06 177.76 160.06 115.25 204.5 106.06 204.5 106.06 211.04 117.66 211.04 180.61 211.04 243.75 160.06 243.75 153.52 209.28 153.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.05,112.41c2.44,7.8,10.74,12.15,18.54,9.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "180.61 204.5 106.06 204.5 177.76 153.52 243.75 153.52 180.61 204.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 163.01,
    y: 129.24,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(239.86 -65.75) rotate(64.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 189.86,
    cy: 153.56,
    r: 14.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "217.58 168.6 165.11 168.26 138.88 187.06 190.34 188.13 217.58 168.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.71,
    y: 139.88,
    width: 6.81,
    height: 33.92,
    transform: "translate(-56.76 105.5) rotate(-30.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 152.1,
    y: 138.59,
    width: 6.81,
    height: 3.91,
    transform: "translate(-49.81 98.37) rotate(-30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M152,133.37h2.04c1.32,0,2.38,1.07,2.38,2.38v3.51h-6.81v-3.51c0-1.32,1.07-2.38,2.38-2.38Z",
    transform: "translate(-48.01 96.53) rotate(-30.5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "177.91 178.56 170.78 173.18 176.65 169.73 177.91 178.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "175.67 176.92 177.6 175.78 177.91 178.56 175.67 176.92"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 161.94,
    y: 140.75,
    width: 3.4,
    height: 33.92,
    transform: "translate(-57.4 104.88) rotate(-30.5)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 99.62,
    y: 138.33,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(-84.94 124.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 127.19,
    y: 140.98,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(72.98 374.02) rotate(-124.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 154.47,
    cy: 161.91,
    r: 14.34
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.25,46h-9.16c-15.4,0-27.88,12.48-27.88,27.88v87.59"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstelle3);
export default __webpack_public_path__ + "static/media/estelle_3.1cad1ea4fbc30619c330a164d3c042c7.svg";
export { ForwardRef as ReactComponent };